/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import SalesChannelsVersionLayout from '@/src/layout/SalesChannelsVersionLayout/SalesChannelsVersionLayout';

import { IRoutes } from 'src/types/router';

import routes from 'src/config/routerConfig/salesChannelVersion/salesChannelVersion';

const route: IRoutes = {
  layout: SalesChannelsVersionLayout,
  subRoutes: routes,
};
export default route;
